export enum Log {
  TRACKING = "squirrel.tracking",
  STORAGE = "squirrel.storage"
}
